
export enum DeviceShiftCd {
	DAY_RESHIP = 'DayReship',
	INBOUND = 'Inbound',
	NIGHT_FAC = 'NightFAC',
	OUTBOUND = 'Outbound',
	PICKUP_AND_DELIVERY = 'PickupAndDelivery'}

